import { createSelector } from 'reselect'
import { getSelectedDisplayProduct } from 'quick-quote/product-selection/selectors'
import { getSelectedRiders } from 'quick-quote/product-common/coverage-plan/selectors'
import values from 'core/data-model/constants/values'

export const getProfileSummaryHeader = createSelector(
  getSelectedDisplayProduct,
  getSelectedRiders,
  (displayProduct, riders) => {
    const mehRider = riders.find((rider) => rider.code === values.MEH)

    const planName = mehRider
      ? // $$FlowFixMe
        `${mehRider.selectedPlan.plan} (${mehRider.selectedPlan.planCode})`
      : ''
    return `${displayProduct.name} ${planName}`
  }
)
